/**
 * MIME type validation — pure, dependency-free.
 *
 * Lives in `lib/` (not `middleware/`) so low-level storage code can validate a
 * stored `fileType` without pulling in the middleware/crypto import graph.
 */

// RFC 2045 token characters: any CHAR except CTLs, space, and tspecials.
// This covers alphanumerics plus: !#$%&'*+-.^_`|~
const MIME_TOKEN = "[A-Za-z0-9!#$%&'*+\\-.^_`|~]+";
const MIME_PARAM_VALUE = `(?:${MIME_TOKEN}|"[^"\\\\]*(?:\\\\.[^"\\\\]*)*")`;
const MIME_RE = new RegExp(
  `^${MIME_TOKEN}\\/${MIME_TOKEN}(?:\\s*;\\s*${MIME_TOKEN}=${MIME_PARAM_VALUE})*$`,
);

/**
 * Return the trimmed value if it is a well-formed `type/subtype` MIME string
 * (optionally with parameters), otherwise the empty string. A bare extension
 * like `"mp4"` is not a MIME type and returns `""`.
 */
export function normalizeMimeType(value: string): string {
  const trimmed = value.trim();
  return MIME_RE.test(trimmed) ? trimmed : "";
}
